<template>
  <div>

    <el-row style="margin-bottom:10px;">
      <el-col :span="18" class='flex'>
        <el-input
          v-model="getUserTargetList_data.umName"
          placeholder="请输入名称"
          clearable
          size='small'
          style="max-width:380px;"/>
        <el-button
          v-click.getUserTargetList
          type="primary"
          icon='el-icon-search'
          size='small'
          style='margin-left:10px;'
        >搜索
        </el-button>
      </el-col>
    </el-row>

    <mytable
      :tableColums='tableColums_getUserTargetList'
      api='getUserTargetList'
      updateapi='updateCircleLetter'
      :height="H-165" >
    </mytable> 
  </div>
</template>

<script>
export default {
  data() {
    return {

      tableColums_getUserTargetList: {
        $selection: false,

        utType: ['类型',,'@v-if: 1:战队, 2:学员'],

        utStatus: ['类型',,'@v-if: 1:未完成, 2:已完成'],

          dtName: '分公司',

        userName: '学员',
        
        utTarget: '目标量',

        utComplete: '完成量',

        dtLevel: ['战队等级', 100, '@v-if: 1:省级战队#warn, 2:市级战队#warn, 3:区级战队#warn, 4:网格#warn' ],

        utNumType: ['目标类型', 100, '@v-if: 1:签约家数#warn, 2:签约数量#warn, 3:签约金额#warn' ],

        utCompleteTime: '完成时间',

        createtime: '创建时间',
        
      },

    };
  },

  watch: {
    
  },

  methods: {},

  created() {
    this.getUserTargetList();
  }
};
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/views/User/UserTargetManage.vue